import { render } from "./song.vue?vue&type=template&id=4fd2caa3&scoped=true"
import script from "./song.vue?vue&type=script&lang=js"
export * from "./song.vue?vue&type=script&lang=js"

import "./song.vue?vue&type=style&index=0&id=4fd2caa3&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd2caa3"]])

export default __exports__